export default __webpack_public_path__ + "static/media/empty.5439dc9f.svg";